import { useState, useEffect } from "react";
import api from "./api";

let _cache = null;

export function useConfig() {
  const [config, setConfig] = useState(_cache);
  const [cities, setCities] = useState([]);
  const [genres, setGenres] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [c, ci, g] = await Promise.all([
          _cache ? Promise.resolve({ data: _cache }) : api.get("/config/public"),
          api.get("/cities"),
          api.get("/genres"),
        ]);
        if (!mounted) return;
        _cache = c.data;
        setConfig(c.data);
        setCities(ci.data);
        setGenres(g.data);
      } catch {}
    })();
    return () => { mounted = false; };
  }, []);

  return { config, cities, genres };
}

export const CITY_KEY = "eventra_city";
export function getSavedCity() { return localStorage.getItem(CITY_KEY) || "Ahmedabad"; }
export function saveCity(c) { localStorage.setItem(CITY_KEY, c); }
